/* eslint-disable eqeqeq */

import {
    Box,
    Paper,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import RecipientEntityForm from "./ConfirmAddressOwnershipInput";
import AppButton from "../../../../../components/AppButton";

export default function ConfirmAddressOwnership(
    {
        network,
        cryptoCurrency,
        address,
        handleConfirm,
        updateOwnershipFormData
    }
) {
    const { t } = useTranslation();
    const [ownership, setOwnership] = useState("0");
    const [recipientEntity, setRecipientEntity] = useState("0");
    const [recipientFirstName, setRecipientFirstName] = useState("");
    const [recipientLastName, setRecipientLastName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // /**
    //  * Trigger transfer confirmation
    //  * @returns 
    //  */
    // const transferAction = () => {
    //     setConfirm(true)
    // };
    const isAddressSomeoneElse = () => {
        return ownership === "1"
    }
    const handleNameChange = (e) => {
        if (e.target.name === 'recipientFirstName') {
            setRecipientFirstName(e.target.value);
        }
        if (e.target.name === 'recipientLastName') {
            setRecipientLastName(e.target.value);
        }
        // setAddress(e.target.value);
    }
    const isDisabled = () => {
        if (ownership === "1") {
            if (recipientLastName === '' || recipientFirstName === '') {
                return true;
            }
        }

        return false;
    }
    const resetOwnerShip = () => {
        setRecipientEntity("0");
        setRecipientFirstName('');
        setRecipientLastName('');
    }
    const handleConfirmAction = async () => {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);

        try {
            if (isAddressSomeoneElse()) {
                //only add ownership details if address is not for payee
                updateOwnershipFormData({
                    recipientEntity: recipientEntity === "1" ? "company" : "individual",
                    recipientFirstName,
                    recipientLastName
                });
            }
            await handleConfirm();
        } catch (error) {

        } finally {
            resetOwnerShip();
        }

    }
    const handleOwnershipChange = (type) => {
        updateOwnershipFormData(null); //reset data
        setOwnership(type)
    }
    return <Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
            // minHeight: [1, 2].includes(active) ? "75vh" : "24vh",
        }}
    >
        <Typography
            color={"#D4D4D8"}
            fontSize={18}
            fontWeight={"bold"}
            textAlign="center"
            paddingTop={1}
            paddingBottom={1}
        >
            {t("transfer.confirmWalletAddressOwnershipTitle")}
        </Typography>

        <Typography
            color={"#D4D4D8"}
            //  fontSize={16}
            //  textAlign="center"
            paddingTop={1}
            paddingBottom={1}
        >
            {t("transfer.walletAddressConfirmOwnershipSub")}
        </Typography>
        <Typography
            color={"#D4D4D8"}
            fontWeight={"bold"}
            //  textAlign="center"
            paddingTop={1}
            paddingBottom={1}
        >
            {t("transfer.confirmWalletAddressOwnershipNote")}
        </Typography>

        <Typography
            padding={1}

            fontSize={14}
            sx={{ overflowWrap: "anywhere" }}
        >
            {t('wallet')}
        </Typography>
        <Typography
            padding={1}
            border="1px solid #D4D4D8"
            borderRadius={1}
            fontSize={14}
            sx={{ overflowWrap: "anywhere" }}
        >
            {address}
        </Typography>
        <Box
            display={"flex"}
            flexDirection={"row"}
            marginTop={2}
            justifyContent="space-between"
            width={"100%"}
        >
            <Typography
                fontSize={14}
                fontWeight={700}
                fontFamily={"Manrope"}
            >
                {t("Coin")}: {cryptoCurrency}
            </Typography>
            <Typography
                fontSize={14}
                fontWeight={700}
                fontFamily={"Manrope"}
                textTransform={"capitalize"}
            >
                {t("network")}: {network}
            </Typography>
        </Box>
        <RecipientEntityForm
            isAddressSomeoneElse={isAddressSomeoneElse()}
            ownership={ownership}
            setOwnership={setOwnership}
            loading={isSubmitting}
            setRecipientEntity={setRecipientEntity}
            recipientFirstName={recipientFirstName}
            handleNameChange={handleNameChange}
            recipientEntity={recipientEntity}
            handleOwnershipChange={handleOwnershipChange}
            recipientLastName={recipientLastName}
        />
        <AppButton
            variant="contained"
            size="large"
            color="primary"
            disabled={isDisabled()}
            loading={isSubmitting}
            sx={{
                color: "#041939",
                marginTop: 1,
                fontSize: 16,
                width: "100%",
                textTransform: "capitalize",
                borderRadius: "8px",
                ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
            }}
            onClick={handleConfirmAction}
            title={t("transfer")}
        />
    </Paper >
}

ConfirmAddressOwnership.propTypes = {
    amount: PropTypes.any,
    setActive: PropTypes.func,
    active: PropTypes.number,
    setShowKytBlocked: PropTypes.func,
    setShowKyt: PropTypes.func,
};
